<template>
    <MainPageVue :isHome="true">
        <div v-if="isLoaded">
            <div class="bg-white">
                <div class="container">
                    <Dashboard></Dashboard>
                </div>
            </div>
            <div class="container">
                <FlashSale></FlashSale>
            </div>
            <div class="bg-white mt-4" v-if="isLogin">
                <div class="container">
                    <BuyAgainSlider />
                </div>
            </div>
            <div class="bg-white mt-4" v-if="isLogin">
                <div class="container">
                    <MyWishListSlider />
                </div>
            </div>
            <div class="container">
                <Voucher @notLogin="goLogin()"></Voucher>
            </div>
            <div class="mt-4">
                <div class="container">
                    <div class="tab" v-if="isShowAgency">
                        <div class="tab-itme" :style="getThemeActive('agency')" @click="clickChangeTab('agency')">
                            <img v-if="tab == 'agency'" src="../../../assets/new/icon/ic-tab-agency-active.png"/>
                            <img v-else src="../../../assets/new/icon/ic-tab-agency-inactive.png"/>
                            <div class="tab-itme-text" :style="getThemeActive('agency')">{{ lbl.home.brand }}</div>
                        </div>
                        <div class="tab-itme" :style="getThemeActive('category')" @click="clickChangeTab('category')">
                            <img v-if="tab == 'category'" src="../../../assets/new/icon/ic-category-active.png"/>
                            <img v-else src="../../../assets/new/icon/ic-tab-category-inactive.png"/>
                            <div class="tab-itme-text" :style="getThemeActive('category')">{{ lbl.home.category }}</div>
                        </div>
                    </div>
                    <div class="tab tab-category" v-else>
                        <div class="tab-itme" :style="getThemeActive('category')" @click="clickChangeTab('category')" v-if="isShowCategory">
                            <img v-if="tab == 'category'" src="../../../assets/new/icon/ic-category-active.png"/>
                            <img v-else src="../../../assets/new/icon/ic-tab-category-inactive.png"/>
                            <div class="tab-itme-text" :style="getThemeActive('category')">{{ lbl.home.category }}</div>
                        </div>
                    </div>
                </div>
                <div class="bg-white">
                    <div class="container">
                        <Agency
                            v-if="tab == 'agency' && isShowAgency"
                            ref="init-agency"
                            :config="menu_config"
                            @changeAgency="changeAgency($event)"
                        ></Agency>
                        <Category
                            v-else
                            ref="init-category"
                            :config="menu_config"
                            @changeCategory="changeCategory($event)"
                        ></Category>
                    </div>
                </div>
                <div class="container">
                    <CampaignList
                        v-if="isInitCampaignConfig"
                        :lbl="lbl"
                        :initListConfig="listConfig"
                        :initFilterConfig="filterConfig"
                        :busEvent="busCampaign"
                    ></CampaignList>
                </div>
            </div>
            <ModalMaster :controller="modalController"></ModalMaster>
        </div>
    </MainPageVue>
</template>

<script>
import Vue from "vue";

import Locale from "@/helper/locale/Locale.js";
import Account from "@/helper/AccountHelper";
import { CampaignListConfigBuilder, CampaignListFilterConfigBuilder } from "@/core/Campaign/model/CampaignConfigModel.js";
import LocaleMixin from "@/mixin/LocaleMixin";
import AccountMixin from "@/mixin/AccountMixin";
import ModalMixin from "@/mixin/ModalMixin";
import Util from "@/helper/Utility";
import ConfigManager from "@/config/ConfigManager";
import { QueryStringDataBuilder } from '@/core/QueryString/QueryStringDataBuilder';
import BlobService from "@/service/BlobService.js";
import ModalMaster from "@/components/Modal/ModalMaster.vue";
//component
import MainPageVue from '@/components/Layout/Page/MainPage.vue'
import Dashboard from '../component/Dashboard.vue';
import FlashSale from '../component/FlashSaleTab.vue';
import Voucher from '../component/Voucher.vue';
import Agency from '../component/Agency.vue';
import Category from '../component/Category.vue';
import CampaignList from '@/module/List/component/CampaignList.vue';
import BuyAgainSlider from '../component/BuyAgain/BuyAgainSlider.vue';
import MyWishListSlider from "../component/WishList/MyWishListSlider.vue";

export default {
    name: "Home",
    mixins: [LocaleMixin,AccountMixin,ModalMixin],
    components: {
        ModalMaster,
        MainPageVue,
        Dashboard,
        FlashSale,
        Voucher,
        Agency,
        Category,
        CampaignList,
        BuyAgainSlider,
        MyWishListSlider
    },
    data: function() {
        return {
            lbl: Locale.getLbl(),
            tab: "agency",
            tabActiveStyle: {
                background: "#f8a51b",
                color: "#ffffff",
            },
            tabInActiveStyle: {
                color: "#333333",
            },

            categoryIdDefault: null,
            agencyIdDefault: null,

            listConfig: {},
            filterConfig: {},
            busCampaign: new Vue(),

            isInitCampaignConfig: false,
            menu_config: "",
            isShowAgency: false,
            isShowVoucher: true,
            isShowCategory: true,

            isLoaded: false
        }
    },
    created: function() {
        // this.accountInitiated();
    },
    methods: {
        accountInitiated: function() {
            if (this.isLogin) {
                this.isLoaded = true
                this.initialBlobConfig()
                this.isTab()
                this.initTabConfig()
            } else {
                this.isNoLogin();
            }
        },
        initialBlobConfig: function() {
            this.blobConfig = Account.getCacheBlob();
            this.menu_config = this.blobConfig.category_menu_config;
            this.isShowAgency = this.blobConfig.show_agency || false;
        },
        isNoLogin: async function() {
            this.initQueryString();
            await this.getBlobConfig();
            await this.getSearchListConfig();
            this.isLoaded = true
            this.initialBlobConfig()
            this.isTab()
            this.initTabConfig()
        },
        initQueryString: async function () {
            let app_id = '5301489996600029';
            if(!Util.isEmptyStr(app_id)) {
                ConfigManager.setAppId(app_id);
                const query = {
                    app_id: app_id
                };
                this.query = new QueryStringDataBuilder()
                .setWithQuery(query)
                .create();

                Account.setCacheQuery(this.query)
                this.blobURL  = `${ConfigManager.getBlobUrl()}/config/b2b_marketplace/${app_id}`;
                this.blobCartURL  = `${ConfigManager.getBlobUrl()}/config/b2b_marketplace`;

            } else {
                this.blobURL  = `${ConfigManager.getBlobUrl()}/config/b2b_marketplace/${ConfigManager.getAppId()}`;
                this.blobCartURL  = `${ConfigManager.getBlobUrl()}/config/b2b_marketplace`;
            }
        },
        getBlobConfig: async function () {
            return new Promise((resolve, reject) => {
                BlobService.apiGetConfig(`${this.blobURL}`, "config.json")
                .then(res => {
                    this.blobConfig = res.data;
                    Account.setCacheBlob(this.blobConfig)
                    console.log(res.data);
                    resolve(true);
                })
                .catch(ex => {
                    console.log(ex)
                    reject(false);
                });
            });
        },
        getSearchListConfig: async function () {
            var searchfile = `searchlist/${this.localeCode}.json`;
            return new Promise((resolve, reject) => {
                BlobService.apiGetConfig(`${this.blobURL}`, searchfile)
                .then(res => {
                    console.log(res.data);
                    this.searchlist = res.data;
                    Account.setCacheCustom('searchlist',this.searchlist)
                    resolve(true);
                })
                .catch(ex => {
                    console.log(ex)
                    reject(false);
                });
            });
        },
        isTab: function () {
            return this.isShowAgency ? this.tab = "agency" : this.tab = "category"
        },
        initTabConfig: function () {
            if (this.tab == "agency") {
                this.$nextTick(() => {
                    this.$refs['init-agency'].initialAgency();
                });
            } else {
                this.$nextTick(() => {
                    this.$refs['init-category'].initialCategory();
                });
            }
        },
        getThemeActive: function(strTab) {
            if (this.tab == strTab) {
                return this.tabActiveStyle;
            } else {
                return this.tabInActiveStyle;
            }
        },
        clickChangeTab: function(strTab) {
            if (this.tab == strTab) return;
            this.tab = strTab;
            if (strTab  == "category") {
                this.categoryIdDefault = null;
            } else {
                this.agencyIdDefault = null;
            }
            this.initTabConfig();
        },
        initialConfig: function(objConfigCampaign) {

            var listConfig = new CampaignListConfigBuilder()
                .setConfigList(objConfigCampaign.list_config)
                .setTop(25)
                .setSortby('score');

            if (objConfigCampaign.id)
                listConfig.setCatId(objConfigCampaign.id);

            this.listConfig = listConfig.create();

            var filterConfig = new CampaignListFilterConfigBuilder();

            if (objConfigCampaign.agencyid)
                filterConfig.setLocationAgency(objConfigCampaign.agencyid);

            this.filterConfig = filterConfig.create();

            this.isInitCampaignConfig = true;

            this.busCampaign.$emit('reInitList', {
                listConfig: this.listConfig,
                filterConfig: this.filterConfig,
            });
        },
        changeAgency: function (agency) {
            this.isInitCampaignConfig = false;
            var objAgency = {
                list_config: agency.list_config,
                agencyid: agency.id
            }
            this.initialConfig(objAgency);
        },
        changeCategory: function (category) {
            if (category.code) {
                this.isShowCategory = false
            }
            this.isInitCampaignConfig = false;

            this.initialConfig(category);
        },
        goLogin: function() {
            this.confirmModal
                .clearModal()
                .setTitle(this.lbl.alert_popup.login.title)
                .setMsg(this.lbl.alert_popup.login.msg)
                .setBtnOk(this.lbl.alert_popup.login.btnOk)
                .setBtnCancel(this.lbl.alert_popup.login.btnCancel)
                .show();
            this.confirmModal.onClickOk(() => {
                this.$router.push('/login')
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "./NewHome.scss";
</style>
